import React from "react";
import "./SortGroup.scss";

import PropTypes from "prop-types";

import SortItem from "./SortItem";

import * as perm from "../../utils/perm";

const checkMap = {
  ttl: perm.canSortTtl,
  cpc: perm.canSortCpc,
  kpi: perm.canSortKpi,

  clicks: perm.canSortClicks,
  clicks_top: perm.canSortClicksTop,
  importance: perm.canSortImportance,

  shows: perm.canSortShows,
  shows_top: perm.canSortShowsTop,

  ctr_top: perm.canSortCtrTop
};

const sortGroups = [
  [
    { name: "Дата создания", name_short: "Дата", value: "date_add" },
    { name: "Дата редактирования", name_short: "Редакт", value: "date_edit" },

    { name: "Срок открутки", name_short: "Срок", value: "ttl" },

    { name: "CPC", name_short: "CPC", value: "cpc" },
    { name: "KPI", name_short: "KPI", value: "kpi" },
    { name: "Тесты", name_short: "Тесты", value: "tests" }
  ],

  [
    { name: "По выходам", name_short: "Клики (О)", value: "clicks" },
    { name: "По информеру", name_short: "Клики (И)", value: "clicks_inf" },
    { name: "По топу", name_short: "Клики (Т)", value: "clicks_top" },
    { name: "По важности", name_short: "Важность", value: "importance" }
  ],

  [
    { name: "Показы Общие", name_short: "Показы (О)", value: "shows" },
    { name: "Показы Информер", name_short: "Показы (И)", value: "shows_inf" },
    { name: "Показы Топ", name_short: "Показы (Т)", value: "shows_top" }
  ],

  [
    { name: "CTR Информер", name_short: "CTR (И)", value: "ctr_inf" },
    { name: "CTR Топ", name_short: "CTR (Т)", value: "ctr_top" }
  ]
];

function defaultTrue() {
  return true;
}

function getSortGroups(permissions) {
  return sortGroups.map(group => {
    return group.filter(groupItem => {
      const allow = checkMap[groupItem.value] || defaultTrue;
      return allow(permissions);
    });
  });
}

const SortGroup = ({ sortBy, sortOrder, onChange, permissions }) => {
  const groups = getSortGroups(permissions);

  return (
    <div className="sort-group">
      {groups.map((sortOptions, i) => (
        <SortItem
          options={sortOptions}
          sortBy={sortBy}
          sortOrder={sortOrder}
          onChange={onChange}
          key={i}
        />
      ))}
    </div>
  );
};

SortGroup.propTypes = {
  sortOrder: PropTypes.string,
  sortBy: PropTypes.string,
  onChange: PropTypes.func
};

SortGroup.defaultProps = {
  sortBy: "date",
  sortOrder: "desc",
  permissions: []
};

export default SortGroup;
